import React, { useEffect } from 'react';
import styled from 'styled-components';

const ACCOUNTSIQ_URL = 'https://accounts.acroniq.co.uk';

const AcronIQLoginForm = () => {
  useEffect(() => {
    // Redirect to AccountsIQ login with return URL
    const returnUrl = `${window.location.origin}/auth/callback`;
    window.location.href = `${ACCOUNTSIQ_URL}/login?redirect=${encodeURIComponent(returnUrl)}`;
  }, []);

  return (
    <StyledWrapper>
      <div className="container">
        <div className="heading">AcronIQ Veritus</div>
        <div className="subheading">Intelligence With Purpose</div>
        <div className="form-title">Redirecting to login...</div>
        <div style={{ textAlign: 'center', marginTop: '20px', color: '#a0a0a0' }}>
          You will be redirected to AccountsIQ for authentication.
        </div>
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .container {
    max-width: 380px;
    background: #1a1a1a;
    border-radius: 24px;
    padding: 40px;
    border: 1px solid rgba(200, 161, 91, 0.2);
    box-shadow: rgba(200, 161, 91, 0.15) 0px 30px 60px -12px, rgba(200, 161, 91, 0.25) 0px 18px 36px -18px;
    margin: 20px;
    position: relative;
    overflow: hidden;
  }

  .container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #C8A15B 0%, #D4B068 50%, #C8A15B 100%);
    border-radius: 24px 24px 0 0;
  }

  .heading {
    text-align: center;
    font-weight: 900;
    font-size: 28px;
    color: #C8A15B;
    margin-bottom: 5px;
    background: linear-gradient(135deg, #C8A15B 0%, #D4B068 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .subheading {
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    color: #a0a0a0;
    margin-bottom: 15px;
    font-style: italic;
  }

  .form-title {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    color: #f5f5f5;
    margin-bottom: 20px;
  }

  .form {
    margin-top: 20px;
  }

  .error-message {
    background: linear-gradient(135deg, #FEE2E2 0%, #FECACA 100%);
    color: #DC2626;
    padding: 12px 16px;
    border-radius: 12px;
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #FCA5A5;
    text-align: center;
  }

  .form .input {
    width: 100%;
    background: #2a2a2a;
    border: 1px solid rgba(200, 161, 91, 0.3);
    padding: 16px 20px;
    border-radius: 12px;
    margin-top: 15px;
    box-shadow: rgba(200, 161, 91, 0.1) 0px 4px 12px;
    transition: all 0.3s ease;
    font-size: 15px;
    color: white;
    font-weight: 500;
  }

  .password-container {
    position: relative;
    width: 100%;
    margin-top: 15px;
  }

  .password-input {
    padding-right: 55px !important;
    margin-top: 0 !important;
  }

  .password-toggle {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #9CA3AF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border-radius: 6px;
    transition: all 0.2s ease;
    z-index: 10;
  }

  .password-toggle:hover {
    color: #C8A15B;
    background: rgba(200, 161, 91, 0.2);
  }

  .password-toggle:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .form .input::-moz-placeholder {
    color: #808080;
  }

  .form .input::placeholder {
    color: #808080;
  }

  .form .input:focus {
    outline: none;
    border: 1px solid #C8A15B;
    box-shadow: rgba(200, 161, 91, 0.3) 0px 0px 0px 3px, rgba(200, 161, 91, 0.15) 0px 4px 12px;
    transform: translateY(-1px);
    background: #333333;
  }

  .form .input:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: #2a2a2a;
    color: #808080;
  }

  .form .forgot-password {
    display: block;
    margin-top: 12px;
    margin-left: 10px;
  }

  .form .forgot-password a {
    font-size: 12px;
    color: #C8A15B;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
  }

  .form .forgot-password a:hover {
    color: #D4B068;
  }

  .form .login-button {
    display: block;
    width: 100%;
    font-weight: 600;
    background: linear-gradient(135deg, #C8A15B 0%, #D4B068 50%, #C8A15B 100%);
    color: #0a0a0a;
    padding: 16px;
    margin: 25px auto 0;
    border-radius: 12px;
    box-shadow: rgba(200, 161, 91, 0.4) 0px 8px 25px -8px;
    border: none;
    transition: all 0.3s ease;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .form .login-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  .form .login-button:hover {
    transform: translateY(-2px);
    box-shadow: rgba(200, 161, 91, 0.5) 0px 12px 30px -8px;
  }

  .form .login-button:hover::before {
    left: 100%;
  }

  .form .login-button:active {
    transform: translateY(0px);
    box-shadow: rgba(200, 161, 91, 0.3) 0px 4px 15px -5px;
  }

  .form .login-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: rgba(200, 161, 91, 0.2) 0px 4px 15px -5px;
  }

  .form .login-button:disabled:hover {
    transform: none;
    box-shadow: rgba(200, 161, 91, 0.2) 0px 4px 15px -5px;
  }

  .toggle-container {
    text-align: center;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid rgba(200, 161, 91, 0.2);
  }

  .toggle-text {
    color: #a0a0a0;
    font-size: 14px;
    font-weight: 500;
  }

  .toggle-link {
    background: none;
    border: none;
    color: #C8A15B;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.2s ease;
    padding: 0;
    margin-left: 4px;
  }

  .toggle-link:hover {
    color: #D4B068;
    text-decoration: underline;
  }

  .toggle-link:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }



  /* Responsive Design */
  @media (max-width: 480px) {
    .container {
      max-width: 320px;
      padding: 25px 30px;
      margin: 10px;
    }
    
    .heading {
      font-size: 24px;
    }
    
    .subheading {
      font-size: 12px;
    }
  }
`;

export default AcronIQLoginForm;
